export const entityModes = {
  select: 'select',
  create: 'create',
  edit: 'edit',
  delete: 'delete',
};

export const workScheduleByPeriodFormModes = {
  create: 'create',
  edit: 'edit',
  duplicate: 'duplicate',
};

export const workScheduleByPeriodFields = {
  period: 'period',
  address: 'address',
  allCompanyAddresses: 'address.allCompanyAddresses',
  cityIds: 'address.cityIds',
  cityRegionIds: 'address.cityRegionIds',
  streetIds: 'address.streetIds',
  houseIds: 'address.houseIds',
  workers: 'workers',
  serviceSets: 'serviceSets',
};

export const workScheduleByPeriodFieldAccess = {
  [workScheduleByPeriodFormModes.create]: {},
  [workScheduleByPeriodFormModes.edit]: {
    [workScheduleByPeriodFields.period]: false,
    [workScheduleByPeriodFields.cityIds]: false,
  },
  [workScheduleByPeriodFormModes.duplicate]: {
    [workScheduleByPeriodFields.period]: true,
    [workScheduleByPeriodFields.address]: true,
    [workScheduleByPeriodFields.workers]: true,
    [workScheduleByPeriodFields.serviceSets]: true,
  },
};

export const workScheduleByPeriodInitialValueAccess = {
  [workScheduleByPeriodFormModes.create]: {},
  [workScheduleByPeriodFormModes.edit]: {},
  [workScheduleByPeriodFormModes.duplicate]: {
    [workScheduleByPeriodFields.period]: false,
  },
};

export const workerFilterFieldNames = {
  speciality: 'workerFilterSpeciality',
  role: 'workerFilterRole',
};

export const serviceSetFilterFieldNames = {
  immediate: 'serviceSetFilterImmediate',
  service: 'serviceSetFilterService',
  selection: 'serviceSetFilterSelection',
};

export const serviceSetFilterSelectionValues = {
  immediate: 'immediate',
  selected: 'selected',
  unselected: 'unselected',
};

export const workerRoles = {
  executor: 'executor',
  master: 'master',
};

export const workerRoleOptions = [
  {
    key: workerRoles.executor,
    value: workerRoles.executor,
    text: 'Исполнитель',
    content: 'Исполнитель',
  },
  {
    key: workerRoles.master,
    value: workerRoles.master,
    text: 'Мастер',
    content: 'Мастер',
  },
];

export const modeSwitcherOptions = [
  {
    value: entityModes.select,
    label: 'Выбрать',
  },
  {
    value: entityModes.create,
    label: 'Создать',
  },
  {
    value: entityModes.edit,
    label: 'Изменить',
  },
  {
    value: entityModes.delete,
    label: 'Удалить',
  },
];
